export const RA_DISMISS_PANEL_LS_KEY = 'KBUI_RA_DISMISS_PANEL';
export const TINYMCE_POPOVER_SEEN_LS_KEY = 'KB_NEW_EDITOR_POPOVER_SEEN';
export const TINYMCE_INSERT_POPOVER_SEEN_LS_KEY = 'KB_NEW_INSERT_MENU_POPOVER_SEEN';
export const NO_INDEX_SEARCH_RESULTS_DISMISS_ALERT_KEY = 'KBUI_NO_INDEX_SEARCH_RESULTS_DISMISS_ALERT';
export const NO_INDEX_SEARCH_RESULTS_DISMISS_MODAL_KEY = 'KBUI_NO_INDEX_SEARCH_RESULTS_DISMISS_MODAL';
export const DISABLE_POPOVERS_LS_KEY = 'knowledge-base:disable-one-time-dialogs';
export const V3_OPT_IN_DISMISS_LS_KEY = 'knowledgebase:v3OptInDismiss';
export function getItem(key, defaultValue) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return defaultValue;
  }
}
export const getIsAcceptanceTest = () => getItem(DISABLE_POPOVERS_LS_KEY, false) === 'true';
const disableIfAcceptanceTest = actualLocalStorageValue => {
  if (getItem(DISABLE_POPOVERS_LS_KEY, false) === 'true') {
    return true;
  }
  return actualLocalStorageValue;
};
export function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    void 0;
  }
}
export const noIndexSearchResultsNoticeLocalStorage = {
  alertDismissed: () => disableIfAcceptanceTest(Boolean(getItem(NO_INDEX_SEARCH_RESULTS_DISMISS_ALERT_KEY, true))),
  setAlertDismiss: () => setItem(NO_INDEX_SEARCH_RESULTS_DISMISS_ALERT_KEY, true),
  modalDismissed: () => disableIfAcceptanceTest(Boolean(getItem(NO_INDEX_SEARCH_RESULTS_DISMISS_MODAL_KEY, true))),
  setModalDismiss: () => setItem(NO_INDEX_SEARCH_RESULTS_DISMISS_MODAL_KEY, true)
};
export const tinymceLocalStorage = {
  insertPopoverSeen: () => disableIfAcceptanceTest(Boolean(getItem(TINYMCE_INSERT_POPOVER_SEEN_LS_KEY, true))),
  setInsertPopoverDismiss: () => setItem(TINYMCE_INSERT_POPOVER_SEEN_LS_KEY, true)
};
export const bufferedUpdateWarningLocalStorage = {
  getPopoverCount: () => {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
    return getItem('BUFFERED_UPDATE_WARNING_COUNT_KEY');
  },
  setPopoverDismiss: count => {
    if (!count) {
      return setItem('BUFFERED_UPDATE_WARNING_COUNT_KEY', 1);
    }
    const newCount = Number(count) + 1;
    return setItem('BUFFERED_UPDATE_WARNING_COUNT_KEY', newCount);
  }
};